import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const ProjectsSection = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const projects = [
    {
      name: "Bulk Leads Caller",
      description: "Professional lead management mobile app",
      status: "Live",
      category: "Mobile App"
    },
    {
      name: "Sales Analytics Dashboard",
      description: "Real-time sales performance tracking",
      status: "In Development",
      category: "Web App"
    },
    {
      name: "CRM Integration Suite",
      description: "Seamless CRM connectivity tools",
      status: "Planning",
      category: "Enterprise"
    },
    {
      name: "Call Center Automation",
      description: "AI-powered call center solutions",
      status: "Research",
      category: "AI/ML"
    }
  ];

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <section className="py-20 bg-gradient-to-r from-purple-600 via-purple-500 to-pink-500 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-20 h-20 bg-white rounded-full"></div>
        <div className="absolute top-32 right-20 w-16 h-16 bg-white rounded-full"></div>
        <div className="absolute bottom-20 left-32 w-12 h-12 bg-white rounded-full"></div>
        <div className="absolute bottom-32 right-10 w-24 h-24 bg-white rounded-full"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center">
          {/* Main Heading */}
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Imagination, Creativity & Innovation
          </h2>
          
          {/* Subheading */}
          <p className="text-xl md:text-2xl text-white/90 italic mb-12 font-light">
            Ideas conceptualised and realised.
          </p>

          {/* Projects Dropdown */}
          <div className="relative inline-block">
            <button
              onClick={toggleDropdown}
              className="bg-gray-800 hover:bg-gray-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-200 flex items-center space-x-3 shadow-lg hover:shadow-xl"
            >
              <span>Projects</span>
              {isDropdownOpen ? (
                <ChevronUp className="w-5 h-5" />
              ) : (
                <ChevronDown className="w-5 h-5" />
              )}
            </button>

            {/* Dropdown Menu */}
            {isDropdownOpen && (
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 w-80 bg-white rounded-lg shadow-xl border border-gray-200 z-20">
                <div className="p-4">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Our Projects</h3>
                  <div className="space-y-3">
                    {projects.map((project, index) => (
                      <div key={index} className="p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
                        <div className="flex justify-between items-start mb-2">
                          <h4 className="font-semibold text-gray-900">{project.name}</h4>
                          <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                            project.status === 'Live' ? 'bg-green-100 text-green-800' :
                            project.status === 'In Development' ? 'bg-blue-100 text-blue-800' :
                            project.status === 'Planning' ? 'bg-yellow-100 text-yellow-800' :
                            'bg-gray-100 text-gray-800'
                          }`}>
                            {project.status}
                          </span>
                        </div>
                        <p className="text-sm text-gray-600 mb-1">{project.description}</p>
                        <p className="text-xs text-gray-500">{project.category}</p>
                      </div>
                    ))}
                  </div>
                  
                  {/* Footer */}
                  <div className="mt-4 pt-3 border-t border-gray-200">
                    <p className="text-xs text-gray-500 text-center">
                      More projects coming soon...
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Click outside to close dropdown */}
      {isDropdownOpen && (
        <div 
          className="fixed inset-0 z-10" 
          onClick={() => setIsDropdownOpen(false)}
        ></div>
      )}
    </section>
  );
};

export default ProjectsSection;
